<template>
  <div class="grid h-screen grid-rows-[auto_1fr]">
    <div class="align-items-start grid gap-y-14">
      <HeaderLogo />

      <Frame>
        <Img
          class="pb-5 pt-1"
          src="/images/error/404.svg"
          alt="404 Not Found お探しのページが見つかりません"
        />
        <p class="mx-4">
          ご利用いただきありがとうございます。<br />
          申し訳ございませんが、アクセスいただいたページが見つかりません。<br />
        </p>
      </Frame>

      <NuxtLink to="/">
        <Img src="/images/error/to-top.svg" alt="トップページへ戻る" />
      </NuxtLink>
    </div>

    <VFooter />
  </div>
</template>

<script setup lang="ts">
useHead(() => ({
  title: 'ページが見つかりません | 英語力測定テスト | NHK出版',
  meta: [
    {
      name: 'robots',
      content: 'noindex,nofollow',
    },
  ],
}));
</script>
